import {areSearchTypesSortable} from './areSearchTypesSortable';
import {rulesContainCurrentCart} from '../rules/cart/utils/rulesContainCurrentCart';
import type {SearchRules} from '../rules/types';

/**
 * Check if search rules are sortable (on the server)
 * @param searchRules
 * @returns Search rules are sortable
 */
export const areSearchRulesSortable = (searchRules: SearchRules) =>
	areSearchTypesSortable(searchRules.elementTypes) &&
	!rulesContainCurrentCart(searchRules);

export default areSearchRulesSortable;
